import {NavItem} from "../components/FormNav/NavItem";
import {NavItemType} from "../components/FormNav/NavItemType";
import FormPages from "./FormPages";

export const Miscellaneous_BASE_URL = "/Profile/${id}/ClientProfile/EstateFlowchart/${flowchartId}/Miscellaneous/${estateItemId}/";

export const MiscellaneousFormPages: NavItem[] = [
    {
        id: FormPages.BASIC_INFORMATION.id,
        displayName: FormPages.BASIC_INFORMATION.displayName,
        type: NavItemType.PAGE,
        index: 0,
        pathTemplate: Miscellaneous_BASE_URL + FormPages.BASIC_INFORMATION.id
    } as NavItem
]